import React from 'react';
import ServiceCard from './ServiceCard';
import pressReleaseImage from '../img/press-release.jpg';

const Services = () => {
  const services = [
    {
      id: 'advertisement', // Add id field
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      icon: "fas fa-ad",
      title: "Advertisement",
      description: "Creative and strategic advertising solutions across digital and traditional media to maximize your brand visibility and customer reach."
    },
    {
      id: 'marketing', // Add id field
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      icon: "fas fa-bullseye",
      title: "Marketing",
      description: "Comprehensive marketing strategies tailored to your business goals, including digital, content, and influencer marketing solutions."
    },
    {
      id: 'press-release', // Add id field
      image: pressReleaseImage, 
      icon: "fas fa-newspaper",
      title: "Press Release",
      description: "Professional press release writing and distribution services to effectively communicate your news to media outlets and target audiences."
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <div className="section-title">
              <h2>Our Professional Services</h2>
              <p className="text-muted">Expert solutions to enhance your brand communication and market presence</p>
            </div>
          </div>
        </div>
        <div className="row">
          {services.map((service, index) => (
            <ServiceCard 
              key={index} 
              id={service.id} // Pass the id prop
              image={service.image}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;